import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Home, Dumbbell, Utensils, TrendingUp, User, Users, ShieldCheck, Library, BookUser, IndianRupee } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { UserRole } from '../shared/roles';

const USER_TABS = [
  { path: '/dashboard', label: 'Home', icon: Home },
  { path: '/workout', label: 'Workout', icon: Dumbbell },
  { path: '/diet', label: 'Diet', icon: Utensils },
  { path: '/progress', label: 'Progress', icon: TrendingUp },
  { path: '/profile', label: 'Profile', icon: User },
];

const TRAINER_TABS = [
  { path: '/trainer/dashboard', label: 'Home', icon: Home },
  { path: '/trainer/clients', label: 'Clients', icon: Users },
  { path: '/trainer/meals', label: 'Meals', icon: Utensils },
  { path: '/trainer/exercises', label: 'Library', icon: Library },
  { path: '/profile', label: 'Profile', icon: User },
];

const GYM_TABS = [
  { path: '/gym/dashboard', label: 'Home', icon: Home },
  { path: '/gym/clients', label: 'Clients', icon: Users },
  { path: '/gym/trainers', label: 'Trainers', icon: Dumbbell },
  { path: '/profile', label: 'Profile', icon: User },
];

const ADMIN_TABS = [
  { path: '/admin/queue', label: 'Queue', icon: ShieldCheck },
  { path: '/admin/directory', label: 'Directory', icon: BookUser },
  { path: '/admin/pricing', label: 'Pricing', icon: IndianRupee },
  { path: '/profile', label: 'Profile', icon: User },
];

const pickTabs = (role) => {
  if (role === UserRole.TRAINER) return TRAINER_TABS;
  if (role === UserRole.GYM_OWNER) return GYM_TABS;
  if (role === UserRole.ADMIN) return ADMIN_TABS;
  return USER_TABS;
};

export default function BottomNav() {
  const location = useLocation();
  const { user } = useAuth();
  const tabs = pickTabs(user?.role);
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-[#161616] border-t border-[#262626] safe-bottom" data-testid="bottom-nav">
      <div className="max-w-lg mx-auto flex items-center justify-around h-16">
        {tabs.map(({ path, label, icon: Icon }) => {
          const active = location.pathname === path;
          return (
            <Link
              key={path}
              to={path}
              data-testid={`tab-${label.toLowerCase()}`}
              className={`flex flex-col items-center gap-1 py-2 px-3 transition-colors duration-200 ${
                active ? 'text-[#C6A85B]' : 'text-[#A3A3A3]'
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 1.5} />
              <span className="text-[10px] font-body font-semibold tracking-wide">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
